import Headphones from '@mui/icons-material/Headphones';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import OndemandVideo from '@mui/icons-material/OndemandVideo';
import PlayCircle from '@mui/icons-material/PlayCircle';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useState } from 'react';
import { MenuBook } from '@mui/icons-material';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

// src/universal/site-choices/index.tsx
var sites = [
  {
    name: "Watch",
    value: "watch"
  },
  {
    name: "Listen",
    value: "listen"
  },
  {
    name: "Play",
    value: "play"
  },
  {
    name: "TIL",
    value: "til"
  }
];
var siteIcons = {
  listen: /* @__PURE__ */ jsx(Headphones, { fontSize: "small" }),
  watch: /* @__PURE__ */ jsx(OndemandVideo, { fontSize: "small" }),
  play: /* @__PURE__ */ jsx(PlayCircle, { fontSize: "small" }),
  til: /* @__PURE__ */ jsx(MenuBook, { fontSize: "small" })
};
var SiteChoices = (props) => {
  const { sites: siteUrls, activeSite } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const active = sites.find((site) => site.value === activeSite);
  const activeSiteName = active == null ? void 0 : active.name;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        "aria-label": "site choices",
        onClick: handleClick,
        endIcon: /* @__PURE__ */ jsx(KeyboardArrowDown, {}),
        size: "small",
        sx: { ml: 1, minWidth: 100 },
        startIcon: siteIcons[active == null ? void 0 : active.value],
        children: activeSiteName
      }
    ),
    /* @__PURE__ */ jsx(Menu, { anchorEl, open, onClose: handleClose, children: sites.map((site) => /* @__PURE__ */ jsxs(
      MenuItem,
      {
        component: "a",
        "aria-label": site.name,
        href: siteUrls[site.value],
        selected: site.value === activeSite,
        children: [
          /* @__PURE__ */ jsx(ListItemIcon, { children: siteIcons[site.value] }),
          /* @__PURE__ */ jsx(ListItemText, { children: site.name })
        ]
      },
      site.value
    )) })
  ] });
};
var site_choices_default = SiteChoices;

export { site_choices_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-SMV7EJNI.mjs.map